import Cookies from 'js-cookie';
import { apiRequest } from '@/utils/api-request';

const BASE = '/api/parent-app/admin';

const apiBase = () => {
  const url = import.meta.env.VITE_API_URL as string | undefined;
  return url?.replace('/api', '') ?? 'http://localhost:5004';
};

const fetchWithAuth = async (url: string, options: RequestInit) => {
  const token = Cookies.get('erp_auth_token') || Cookies.get('crm_auth_token');
  try {
    const res = await fetch(url, {
      ...options,
      headers: { Authorization: `Bearer ${token ?? ''}`, ...(options.headers ?? {}) },
      credentials: 'include',
    });
    const json = await res.json();
    return { success: json.success ?? res.ok, data: json.data, message: json.message as string | undefined };
  } catch (err: any) {
    return { success: false, message: err.message as string };
  }
};

export interface PaClass {
  id: number;
  class_name: string;
  is_active: boolean;
  curriculum_class_id: number | null;
  section_id: number | null;
}

export interface PostMedia {
  id: number;
  media_url: string;
  media_type: 'image' | 'video';
  sort_order: number;
}

export interface FeedPost {
  id: number;
  uuid: string;
  class_id: number | null;
  class?: { id: number; class_name: string } | null;
  author_type: 'teacher' | 'admin';
  caption: string;
  media: PostMedia[];
  like_count: number;
  comment_count: number;
  created_at: string;
}

export const classFeedApi = {
  getClasses: () =>
    apiRequest<{ data: PaClass[] }>(`${BASE}/pa-classes`),

  getPosts: (class_id?: number, page = 1) => {
    const qs = class_id ? `class_id=${class_id}&page=${page}` : `page=${page}`;
    return apiRequest<{ data: FeedPost[]; total: number; page: number; pages: number }>(
      `${BASE}/posts?${qs}`
    );
  },

  createPost: async (payload: { class_id: number | null; caption: string }, images: File[]) => {
    const formData = new FormData();
    if (payload.class_id) formData.append('class_id', String(payload.class_id));
    formData.append('caption', payload.caption);
    images.forEach(img => formData.append('images', img));
    return fetchWithAuth(`${apiBase()}/api/parent-app/admin/posts`, { method: 'POST', body: formData });
  },

  updatePost: async (postId: number, caption: string, newImages: File[] = []) => {
    const formData = new FormData();
    formData.append('caption', caption);
    newImages.forEach(img => formData.append('images', img));
    return fetchWithAuth(`${apiBase()}/api/parent-app/admin/posts/${postId}`, { method: 'PUT', body: formData });
  },

  deletePost: (postId: number) =>
    apiRequest(`${BASE}/posts/${postId}`, { method: 'DELETE' }),

  deletePostMedia: (postId: number, mediaId: number) =>
    apiRequest(`${BASE}/posts/${postId}/media/${mediaId}`, { method: 'DELETE' }),
};
